import React from "react";
import Modal from "react-modal";
import Icon, { IconName } from "../icon";
import * as styles from "./modal.module.css";
import { useIsEditionSpotlightMagazine } from "../../hooks/use-is-edition-spotlight-magazine";
export default (function (_ref) {
    var isOpen = _ref.isOpen, onRequestClose = _ref.onRequestClose, children = _ref.children;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        shouldCloseOnOverlayClick: true,
        className: useIsEditionSpotlightMagazine() + " " + styles.content,
        overlayClassName: styles.overlay
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: onRequestClose,
        className: styles.closeButton
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.CLOSE,
        color: "#ccc"
    })), children));
});
